export default "__VITE_ASSET__04GvshT7__"